import { render, staticRenderFns } from "./choices-editor.vue?vue&type=template&id=6b48488e&scoped=true&"
import script from "./choices-editor.vue?vue&type=script&lang=js&"
export * from "./choices-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b48488e",
  null
  
)

export default component.exports